import { IPortalPaymentMethodsResponse } from "shared";

import { emptySplitApi } from "../baseApi";
import { PortalCacheTags } from "../cacheTags";

export type PaymentMethodResourceType = `invoice` | `contact`;

interface PaymentMethodArgs {
  resourceType: PaymentMethodResourceType;
  code: string;
  sessionId: string;
}

function baseUrl({ resourceType, code }: PaymentMethodArgs) {
  return `${resourceType === `invoice` ? `invoices` : `contact`}/code/${code}/payment-methods`;
}

function headers({ code, sessionId }: PaymentMethodArgs) {
  return {
    [`X-Portal-Session`]: sessionId,
    [`X-Portal-Hash-Code`]: code,
  };
}

export const paymentMethodsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchPaymentMethods: builder.query<IPortalPaymentMethodsResponse, PaymentMethodArgs>({
      query: args => ({
        url: baseUrl(args),
        method: `GET`,
        headers: headers(args),
      }),
      providesTags: [{ type: PortalCacheTags.PaymentMethods }],
    }),
    createPaymentMethodSetupSession: builder.mutation<{ clientSecret: string }, PaymentMethodArgs>({
      query: args => ({
        url: `${baseUrl(args)}/setup-session`,
        method: `POST`,
        headers: headers(args),
      }),
    }),
    removePaymentMethod: builder.mutation<{ ok: boolean }, PaymentMethodArgs & { paymentMethodId: string }>({
      query: args => ({
        url: `${baseUrl(args)}/${args.paymentMethodId}`,
        method: `DELETE`,
        headers: headers(args),
      }),
      invalidatesTags: [{ type: PortalCacheTags.PaymentMethods }],
    }),
    setDefaultPaymentMethod: builder.mutation<{ ok: boolean }, PaymentMethodArgs & { paymentMethodId: string }>({
      query: args => ({
        url: `${baseUrl(args)}/${args.paymentMethodId}/default`,
        method: `PUT`,
        headers: headers(args),
      }),
      invalidatesTags: [{ type: PortalCacheTags.PaymentMethods }],
    }),
  }),
});

export const {
  useFetchPaymentMethodsQuery,
  useCreatePaymentMethodSetupSessionMutation,
  useRemovePaymentMethodMutation,
  useSetDefaultPaymentMethodMutation,
} = paymentMethodsApi;
